import React from 'react';
import { reduxForm, Field, formValueSelector } from 'redux-form';
import { FormattedMessage, useIntl } from 'react-intl';
import cx from 'classnames';
import Button from 'react-bootstrap/lib/Button';
import CommonFormComponent from '../../CommonField/CommonFormComponent';
import submit from './submit';
import { useSelector } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import { compose } from 'redux';

import cs from '../../../components/commonStyle.css';
import messages from '../../../locale/jsonMessages';

const AIFeaturesManagement = (props) => {
    const { title, submitting, error, handleSubmit } = props;
    const { formatMessage } = useIntl();

    const selector = formValueSelector('AIFeatureForm');
    const isEnable = useSelector(state => selector(state, "aiTextGeneration"));


    const normalizeBoolean = (value) => {
        if (value === true || value === 'true' || value?.toLowerCase() === 'true') return "true";
        if (value === false || value === 'false' || value?.toLowerCase() === 'false') return "false";
        return null;
    };


    const renderFields = (fields) =>
        fields?.map(({ name, labelId, toolTipTextId, tipPlacement }) => (
            <Field
                key={name}
                name={name}
                component={CommonFormComponent}
                toolTipText={formatMessage({ id: toolTipTextId })}
                tipPlacement={tipPlacement}
                normalize={normalizeBoolean}
                labelText={formatMessage({ id: labelId })}
                inputClass='commonSelectField'
            >
                <option value="true">{formatMessage(messages.enableLabel)}</option>
                <option value="false">{formatMessage(messages.disableLabel)}</option>
            </Field>
        ));

    return (
        <form onSubmit={handleSubmit(submit)}>
            {error && <strong>{error}</strong>}
            <h1 className='siteAdminHeading'>{formatMessage(messages.manageAiFeature)}</h1>
            <div className='oneColumnGrid'>
                <div>
                    <p className='siteAdminSecondaryHeading'>{formatMessage(messages.aiTextLabel)}</p>
                    <div className="twoColumnGrid">
                        {renderFields([
                            {
                                name: 'aiTextGeneration',
                                labelId: 'aiTextGeneration',
                                toolTipTextId: 'chatGptTextGenerationTooltip',
                                tipPlacement: 'bottom'
                            }
                        ])}
                    </div>
                </div>
                {
                    isEnable == "true" && (
                        <>
                            {/* Guest Section */}
                            <div>
                                <p className='siteAdminSubHeading'>{formatMessage(messages.guest)}</p>
                                <div className='threeColumnGrid'>
                                    {renderFields([
                                        {
                                            name: 'renterContactMessage',
                                            labelId: 'contactOwnerMessage',
                                            toolTipTextId: 'contactHostMessageTooltip'
                                        },
                                        {
                                            name: 'renterBookingRequest',
                                            labelId: 'bookingRequestMessage',
                                            toolTipTextId: 'bookingRequestMessageTooltip'
                                        },
                                        {
                                            name: 'aiRenterAccess',
                                            labelId: 'servicePlanRenterLabel',
                                            toolTipTextId: 'aiSupportSubscribedGuestsTooltip'
                                        }
                                    ])}
                                </div>
                            </div>

                            {/* Host Section */}
                            <div>
                                <p className='siteAdminSubHeading'>{formatMessage(messages.host)}</p>
                                <div className='threeColumnGrid'>
                                    {renderFields([
                                        {
                                            name: 'aiAccessCarTitleDescription',
                                            labelId: 'carLabel',
                                            toolTipTextId: 'propertyTitleDescriptionTooltip'
                                        },
                                        {
                                            name: 'aiAccessCarMarketPricing',
                                            labelId: 'carPricing',
                                            toolTipTextId: 'propertyMarketPricingTooltip'
                                        },
                                        {
                                            name: 'aiOwnerAccess',
                                            labelId: 'servicePlanOwnerLabel',
                                            toolTipTextId: 'aiSupportSubscribedHostsTooltip'
                                        }
                                    ])}
                                </div>
                            </div>
                        </>
                    )
                }
            </div>
            <div className={cx('singleBtnFlexEnd', cs.spaceTop4)}>
                <Button type="submit" disabled={submitting} className={cs.btnPrimary}>
                    <FormattedMessage  {...messages.save} />
                </Button>
            </div>
        </form>
    );
};

export default compose(
    withStyles(cs),
    reduxForm({
        form: 'AIFeatureForm',
    }))(AIFeaturesManagement);
